import { useTranslation } from "react-i18next";
import { PollsLibrary } from "@/partner/features/pollsLibrary";
import { Meta } from "@/shared/components";

export function PollsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("pollsLibrary.pageTitle")} pageType="Partner" />
      <PollsLibrary />
    </>
  );
}
